<template>
    <div class="newObjectTag" @click="clickEvent">
      <pt-icon type="icon-zengjia" class="iconfont"></pt-icon>
    </div>
</template>

<script>
  export default {
    name: 'newObjectTag',
    methods:{
      clickEvent(){
        this.$emit('click')
      }
    }
  }
</script>

<style scoped lang="less">
  .newObjectTag{
    width: 18px;
    height: 16px;
    border: 1px solid #FABE00;
    border-radius: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    .iconfont{
      font-size: 12px;
      color: #FABE00;
    }
  }
</style>